import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment } from '@mui/material'
import TagsApi, { tagProps } from 'api/setting/personnel-managements/tags.api'
import { resetModal, showModal } from 'app/slice/modal.slice'
import HeaderCard from 'component/CardCustom/HeaderCard'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { notiError } from 'component/notifications/notifications'
import MainButton from 'new-components/buttons/main-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'
import FormManageTag from './form-manage-tag'

const permissions = {
    isCreate: isCreate(),
    isDelete: isDelete(),
    isUpdate: isUpdate(),
    isView: isView()
}
const initManageTag: tagProps = {
    tagId: 0,
    color: '',
    tagName: '',
    tagNameEn: '',
    status: 'ACTIVE',
}


const ManageTag = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const [page, setPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(10)
    const [rowCount, setRowCount] = useState(0)
    const [sortBy, setSortBy] = useState('tagId')
    const [sortType, setSortType] = useState('ASC')
    const [search, setSearch] = useState('')
    const [status, setStatus] = useState('ALL')
    const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
    const [statusAlertModal, setStatusAlertModal] = useState('')
    const [id, setId] = useState<number>(0)
    const [name, setName] = useState('')
    const [isOpenSnack, setIsOpenSnack] = useState(false)
    const [typeSnack, setTypeSnack] = useState<any>("success")
    const [labelSnack, setLabelSnack] = useState('')

    const [maganeTag, setManageTag] = useState<any[]>([])
    const [popTag, setPopTag] = useState<boolean>(false)
    const [popTagIsEdit, setPopTagIsEdit] = useState<boolean>(false)
    const [popDataEdit, setPopDataEdit] = useState<any>(initManageTag)

    const loadData = async () => {
        try {
            const resp = await TagsApi.findAll({
                page: page,
                pageLimit: pageLimit,
                search: search,
                sortBy: sortBy,
                sortType: sortType,
                status: status === 'ALL' ? '' : status
            })
            if (resp.status === 200) {
                setRowCount(resp.headers['x-total'])
                setManageTag(resp.data)
            } else {
                setManageTag([])
            }
        } catch (error) {
            notiError('ERROR')
        }
    }

    useEffect(() => {
        loadData()
    }, [page, pageLimit, sortBy, sortType])

    const onCreate = () => {
        setPopDataEdit(initManageTag)
        setPopTagIsEdit(false)
        setPopTag(true)
        dispatch(showModal())
    }

    const onClosePopTag = () => {
        setPopDataEdit(initManageTag)
        setPopTagIsEdit(false)
        setPopTag(false)
        dispatch(resetModal())
    }

    const onActive = () => {
        if (id) {
            TagsApi.updateStatusTag(id, statusAlertModal).then((resp) => {
                if (resp.status === 200) {
                    setIsOpenAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("success")
                    setLabelSnack(t('TAGS.MESSAGE.CHANGE_STATUS'))
                    loadData()
                } else {
                    setIsOpenAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("error")
                    setLabelSnack(t('TAGS.MESSAGE.ERROR'))
                }
            })
        }
    }

    const onDelete = () => {
        if (id) {
            TagsApi.deleteTag(id).then((resp) => {
                if (resp.status === 200) {
                    setIsOpenAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("success")
                    setLabelSnack(t('TAGS.MESSAGE.DEL_SUCCESSFUL'))
                    loadData()
                } else {
                    setIsOpenAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("error")
                    setLabelSnack(t('TAGS.MESSAGE.ERROR'))
                }
            })
        }
    }

    const onEdit = (data: any) => {
        setPopDataEdit(data)
        setPopTagIsEdit(true)
        setPopTag(true)
        dispatch(showModal())
    }

    const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
        setSortType(sortTypeVal)
        setSortBy(sortByVal)
    }

    const handleChangePage = (val: number) => {
        setPage(val)
    }

    const handleChangeRowsPerPage = (limit: number) => {
        setPageLimit(limit)
    }

    const handleChangeStatus = (statusVal: string) => {
        setStatus(statusVal)
    }

    const headCells = [
        { id: 'no', disablePadding: false, label: t('TABLE.NO'), width: '80px', class: 'tb-tag-no' },
        { id: 'tagColor', disablePadding: false, label: t('TAGS.TABLE.COLOR'), width: '120px', class: 'tb-tag-tag-color' },
        { id: 'tagName', disablePadding: false, label: t('TAGS.TABLE.TAGNAME'), class: 'tb-tag-tag-name' },
        { id: 'status', disablePadding: false, label: t('TAGS.TABLE.STATUS'), width: '200px', class: 'tb-tag-status' },
        { id: 'updatedBy', disablePadding: false, label: t('BRANCH.TABLE.CELL.UPDATED_BY'), width: '180px', class: 'tb-tag-updateby' },
        { id: 'action', disablePadding: false, label: 'Action', width: '160px', class: 'tb-tag-action' }
    ]

    const renderData = (objData: any, no: number) => {
        no = page * pageLimit - pageLimit + no + 1
        const { tagId, tagName, color, status, updatedBy, updatedAt } = objData
        const permissUpdate = false
        const statusBtnActive = status === 'ACTIVE' ? true : permissUpdate
        const statusBtnInActive = status === 'INACTIVE' ? true : permissUpdate

        const objRenderData = {
            key: tagId,
            id: tagId,
            obj: objData,
            columns: [
                { option: 'TEXT', align: 'center', label: no },
                { option: 'COMPONENT', align: 'left', component: (<Box sx={{ backgroundColor: color, height: '21px', width: '80px' }} />) },
                { option: 'TEXT', align: 'left', label: tagName },
                { option: 'STATUS', align: 'center', label: status },
                { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
                {
                    option: 'ACTION', align: 'center', label: 'action', values: [
                        { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
                        { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
                        { option: 'DIVIDER', label: '', disabled: false },
                        { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissUpdate },
                        { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissUpdate }
                    ]
                }
            ]
        }
        return (
            <TableRowCommon
                {...objRenderData}
                onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
                oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
                onedit={() => onEdit(objRenderData.obj)}
                ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
            />
        )
    }
    const handleSubmitModal = (id: number, status: string, obj?: any) => {
        setStatusAlertModal(status)
        setId(id)
        setIsOpenAlertModal(true)
        setName(obj.tagName)
    }


    return (
        <Box>
            <FormManageTag
                isOpen={popTag}
                onClosePopTag={onClosePopTag}
                isEdit={popTagIsEdit}
                data={popDataEdit}
                reLoadData={loadData}
            />
            <AlertModal
                isOpen={isOpenAlertModal}
                title={t(`TAGS.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
                message={t(`TAGS.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { tagName: name, status: t(`TAGS.ALERT.${statusAlertModal}`) })}
                type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
                handleClose={() => setIsOpenAlertModal(false)}
                onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
                onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
            />
            <SnackbarComponent
                onOpen={isOpenSnack}
                onClose={() => setIsOpenSnack(false)}
                label={labelSnack}
                type={typeSnack}
                transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
                autoHideTime={3000}
            />
            <HeaderCard text={t('TAGS.TITLE')} />
            <Box paddingX="24px" paddingTop="16px">
                <Grid container spacing="16px">
                    <Grid item xs={2}>
                        <TextInput
                            label={t('TAGS.SEARCH')}
                            value={search}
                            onChange={(event) => {
                                setSearch(event.target.value)
                            }}
                            fullWidth
                            inputProps={{
                                endAdornment: (
                                    <InputAdornment position="end" >
                                        {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                                            <FontAwesomeIcon
                                                icon={faTimes}
                                                onClick={() => {
                                                    setSearch('');
                                                }}
                                                style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <SelectInput
                            onChange={(event) => {
                                const value = event.target.value
                                if (value) {
                                    handleChangeStatus(value)
                                }
                            }}
                            options={[
                                { value: 'ALL', name: t('STATUS.ALL') },
                                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
                            ]}
                            label={t('STATUS.LABEL')}
                            value={status}
                            width="100%"
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <MainButton
                            title={t('INPUT.SEARCH')}
                            type='primary'
                            variant='contained'
                            style={{ width: '120px' }}
                            onClick={() => {
                                setPage(1)
                                loadData()
                            }} />

                    </Grid>
                    <Grid item xs={7} textAlign="right">
                        <MainButton title={t('TAGS.TITLE_CREATE')} disabled={permissions.isCreate.disabled} type='primary' variant='contained' onClick={() => onCreate()} startIcon={<AddCircleIcon />} />
                    </Grid>
                </Grid>

                <Box paddingTop="24px">
                    <TableCustom
                        page={page}
                        pageLimit={pageLimit}
                        sortType={sortType}
                        sortBy={sortBy}
                        onSort={onRequestSort}
                        setPageLimit={handleChangeRowsPerPage}
                        setPage={handleChangePage}
                        rowCount={rowCount}
                        headCells={headCells}
                        rowsData={maganeTag.map((item: any, index: number) => renderData(item, index))}
                        pagination
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default ManageTag